module.exports = __webpack_public_path__ + "img/9788950935665.691db458.jpg";